import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Popper,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import flt from "../assets/images/flt.png";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import DateRangeNew from "../components/reusableComponents/DateRangeNew";
import BodyText from "../components/reusableComponents/BodyText";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import {
  SearchReturnFormDispatch,
  SearchFormDispatch,
  fetchCityDispatch,
  SearchEtravFormDispatch,
  SearchTripjackFormDispatch,
  SearchReturnEtravFormDispatch,
  AddSearchFlightDispatch,
} from "../reducers/HomeReducer";
import { useTranslation } from 'react-i18next'
import Typed from "typed.js";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import DesktopDateNew from "../components/reusableComponents/DesktopDateNew";
import {
  setSelectedDepart,
  setSelectedOrigin,
  setSelectedTrip,
} from "../reducers/UiReducer";
import SearchBus2 from "./SearchBus2";
import HotelForm from "./HotelForm";
const useStyles = makeStyles((theme) => ({
  root: {
    // "& .MuiFormControl-root": {
    //   "& div": {
    //     "& div": {
    //       display: "none",
    //     },
    //   },
    // },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    // "& .MuiInput-underline:after": {
    //   borderBottom: "none",
    // },
    "& input": {
      fontSize: 30,
      fontWeight: 600,
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },

    // "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
    //   {
    //     paddingRight: 0,
    //   },
    // '& div': {
    // 	'& div': {
    // 		'& div': {
    // 			paddingRight: 0,
    // 		},
    // 	},
    // },
    '& .MuiAutocomplete-endAdornment':{
        display:'none'
    },
    '& .MuiAutocomplete-root':{
        padding:0
    }
  },
  radio: {
    "& .MuiRadio-root": {
      color: "white",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "white",
      fontSize: "18px",
      fontWeight: 800,
    },
  },
  radio2: {
    "& .MuiRadio-root": {
      color: "black",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: "14px",
      // fontWeight: 800,
    },
  },
  popper: {
    "& .MuiAutocomplete-listbox": {
      "& :hover": {
        color: "rgb(239, 51, 57)",
        // '& img': {
        // 	background: 'rgb(239, 51, 57)',
        // },
      },
    },
  },
}));
const MMTForm = () => {
  const [result, setResult] = useState([]);
  const [result2, setResult2] = useState([]);
  const classes = useStyles();
  const { t } = useTranslation(); 
  const { city } = useSelector((state) => state.home);
  const { agentlogin } = useSelector((state) => state.user);
  const { tripInfo } = useSelector((state) => state.ui);
  const handleRadio = (event) => {
    setValue(event.target.value); 
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [section, setSection] = useState("flight");
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);
  const [total, SetTotal] = useState(adult + child + infant);
  const [value, setValue] = useState("Economy");
  const [leaving, setLeaving] = useState("DEL");
  const [trip, setTrip] = useState("oneway");
  const [going, setGoing] = useState("CCU");
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const { origin, depart, OriginO, selectedOrigin, selectedDepart } =
    useSelector((state) => state.ui);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [age, setAge] = React.useState("oneway");

  const handleChange = (value) => {
    setAge(value);
    console.log(value);
  };
  const handleSection = (value) => {
    setSection(value);
  };
  
  const handleSubmit = (data) => {
    // console.log(data);
    let org = data.Origin;
    let des = data.Destination;
    let formData = {
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 1,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: selectedOrigin.airport_code,
          Destination: selectedDepart.airport_code,
          FlightCabinClass: 1,
          PreferredDepartureTime: origin,
          // PreferredArrivalTime: '2022-03-18',
        },
        // {
        // 	Origin: 'CCU',
        // 	Destination: 'DEL',
        // 	FlightCabinClass: 1,
        // 	PreferredDepartureTime: '2022-03-18',
        // 	// PreferredArrivalTime: '2022-03-18',
        // },
      ],
      Sources: "WEB",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
      // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
    };
    let formData2 = {
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 2,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: selectedOrigin.airport_code,
          Destination: selectedDepart.airport_code,
          FlightCabinClass: 1,
          PreferredDepartureTime: origin,
          // PreferredArrivalTime: '2022-03-18',
        },
        {
          Origin: selectedDepart.airport_code,
          Destination: selectedOrigin.airport_code,
          FlightCabinClass: 1,
          PreferredDepartureTime: depart,
          // PreferredArrivalTime: '2022-03-18',
        },
      ],
      Sources: "WEB",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
    };
    if (tripInfo === "oneway") {
      // dispatch(
      // 	SearchEtravFormDispatch(formData, history, OriginO, des, origin)
      // );
      // dispatch(SearchFormDispatch(formData, history, OriginO, des, origin));
      // dispatch(AddSearchFlightDispatch(formData));
      history.push({
        pathname: `/oneway/${selectedOrigin.airport_code}/${selectedDepart.airport_code}/${origin}`,
        state: {
          body: formData,
          OriginO: origin,
        },
      });

      // dispatch(
      // 	SearchTripjackFormDispatch(formData, history, OriginO, des, origin)
      // );
    } else {
      history.push({
        pathname:
          selectedOrigin.country_code === "IN" &&
          selectedDepart.country_code === "IN"
            ? `/roundway/${selectedOrigin.airport_code}/${selectedDepart.airport_code}/${origin}/${selectedDepart.airport_code}/${selectedOrigin.airport_code}/${depart}`
            : "/international",
        state: { returnBody: formData2 },
      });
      // dispatch(
      //   SearchReturnFormDispatch(
      //     formData2,
      //     history,
      //     selectedOrigin,
      //     selectedDepart
      //   )
      // );
      // dispatch(
      //   SearchReturnEtravFormDispatch(
      //     formData2,
      //     history,
      //     selectedOrigin,
      //     selectedDepart
      //   )
      // );
      // dispatch(AddSearchFlightDispatch(formData));
      // console.log(formData2);
    }
  };
  // console.log(invoiceOptions);
  const handleSearchOrigin = (event) => {
    let value = event.target.value.toLowerCase();
    // console.log(value);
    let cityData = {
      keywords: value,
      limits: 10,
    };
    dispatch(fetchCityDispatch(cityData));
  };
  const handleChangeTrip = (value) => {
    // console.log(e.target.value);
    // dispatch(setTrip(value));
  };
  useEffect(() => {
    let cityData = {
      keywords: "bo",
      limits: 8,
    };
    dispatch(fetchCityDispatch(cityData));
  }, []);
  const PopperMy = function (props) {
    return (
      <Popper
        {...props}
        style={styles.popper}
        className={classes.popper}
        placement="bottom-start"
      />
    );
  };

  const styles = (theme) => ({
    popper: {
      width: "fit-content",
    },
  });
  return (
    <>
      <Formik
        initialValues={{
          Origin: "",
          Destination: "",
        }}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={handleSubmit}
      >
        {({ submitForm, isSubmitting, setFieldValue, values }) => (
          <>
            <Form >
              
              {section === "flight" ? (
                <>
                
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "0.25rem",
                      padding: "1.25rem 1.875rem",
                    //   boxShadow: "0 0 57px rgb(0 0 0 / 20%)",
                    }}
                  >
                    
                    <Box
            display="flex"
            style={{ top: "-20px", position: "relative",  }}
          >
            <Box  onClick={() => dispatch(setSelectedTrip("oneway"))}
              style={{
                background: tripInfo === "oneway" ? "#e7e7e7" : "",
                padding: "4px",
                borderRadius: "15px",
                cursor:'pointer',
                border:'1px solid lightgrey'
              }}
            >
              <span
                style={{ color: "#000000", fontWeight: "bold", fontSize: 12,marginLeft:5,marginRight:5 }}
              >
                ONEWAY
              </span>
            </Box>
            <Box onClick={() => dispatch(setSelectedTrip("roundtrip"))}
              ml={"5px"}
              style={{
                background: tripInfo === "roundtrip" ? "#e7e7e7" : "",
                padding: "4px",
                borderRadius: "15px",
                cursor:'pointer',
                border:'1px solid lightgrey'
              }}
            >
              <span
                style={{ color: "#000000", fontWeight: "bold", fontSize: 12,marginLeft:5,marginRight:5 }}
              >
                ROUNDWAY
              </span>
            </Box>
          </Box>
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      
                    >
                      <Grid item xs={12} lg={3}>
                        <Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                          }}
                        >
                          <span style={{  }}>
                            FROM
                          </span>
                          <div className={classes.root}>
                            <Autocomplete
                              id="country-select-demo"
                              sx={{
                                // background: "#eee",
                                // borderRadius: "4px",
                                padding: "10px",
                                transition: "none",
                              }}
                              clearOnBlur={true}
                              value={selectedOrigin}
                              PopperComponent={PopperMy}
                              options={
                                city && city.result.length > 0
                                  ? city.result
                                  : []
                              }
                              filterOptions={(options, state) => options}
                              autoHighlight
                              getOptionLabel={(option) =>
                                // `${selectedOrigin ? selectedOrigin?.airport_code : ""}`
                                `${option.city_name} `
                              }
                              renderOption={(props, option) => (
                                <Box
                                  // mr={'5px'}
                                  component="li"
                                  sx={{ "& > img": { mr: 2 } }}
                                  {...props}
                                >
                                  <img
                                    loading="lazy"
                                    width="20"
                                    src={flt}
                                    alt=""
                                  />
                                  <p style={{ fontSize: 16 }}>
                                    {option.city_name} ({option.airport_code}){" "}
                                    {option.airport_name}
                                  </p>
                                  <img style={{marginLeft:10}}
                                    loading="lazy"
                                    width="30"
                                    src={`https://countryflagsapi.com/svg/${option.country_code}`}
                                    alt=""
                                  />
                                </Box>
                              )}
                              onChange={(event, value) => {
                                setFieldValue("Origin", value.airport_code);
                                dispatch(setSelectedOrigin(value));
                                setFrom(value);
                                // console.log(value);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={handleSearchOrigin}
                                  name="origin"
                                />
                              )}
                            />
                          </div>
                          <span style={{ color:'#4a4a4a' }}>
                            {selectedOrigin ? `${selectedOrigin?.airport_code},${selectedOrigin?.airport_name}` : ""}
                          </span>
                        </Box>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                          }}
                        >
                          <span style={{  }}>
                           TO
                          </span>
                          <div className={classes.root}>
                            <Autocomplete
                              id="country-select-demo"
                              sx={{
                                transition: "none",
                              }}
                              clearOnBlur={true}
                              options={
                                city && city.result.length > 0
                                  ? city.result
                                  : []
                              }
                              value={selectedDepart}
                              PopperComponent={PopperMy}
                              filterOptions={(options, state) => options}
                              autoHighlight
                              getOptionLabel={(option) =>
                                `${option.city_name} `
                              }
                              renderOption={(props, option) => (
                                <Box
                                  // mr={'5px'}
                                  component="li"
                                  sx={{ "& > img": { mr: 2 } }}
                                  {...props}
                                >
                                  <img
                                    loading="lazy"
                                    width="20"
                                    src={flt}
                                    alt=""
                                  />
                                  <p style={{ fontSize: 16 }}>
                                    {option.city_name} ({option.airport_code}){" "}
                                    {option.airport_name}
                                  </p>
                                  <img style={{marginLeft:10}}
                                    loading="lazy"
                                    width="30"
                                    src={`https://countryflagsapi.com/svg/${option.country_code}`}
                                    alt=""
                                  />
                                </Box>
                              )}
                              onChange={(event, value) => {
                                setFieldValue(
                                  "Destination",
                                  value.airport_code
                                );
                                // console.log(value.airport_code);
                                dispatch(setSelectedDepart(value));
                                setTo(value);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={handleSearchOrigin}
                                />
                              )}
                            />
                          </div>
                          <span style={{ color:'#4a4a4a' }}>
                            {selectedDepart ? `${selectedDepart?.airport_code},${selectedDepart?.airport_name}` : ""}
                          </span>
                        </Box>
                      </Grid>
                    
                      <Grid item xs={12} lg={tripInfo === "roundtrip" ? 3 : 2}>
                        <Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            paddingLeft: 13,
                          }}
                        >
                          <span style={{  }}>
                            DEPARTURE
                          </span>
                          {tripInfo === "roundtrip"?
                          <>
                          <span style={{marginLeft:10  }}>
                            -
                          </span>
                          <span style={{ marginLeft:10 }}>
                            RETURN
                          </span></>:''}
                          <br></br>
                          
                          <span style={{fontSize: 25,fontWeight:'bold'  }}>
                            {`  ${new Date(
                            origin.substr(0, 10)
                          ).getDate()} ${new Date(
                            origin.substr(0, 10)
                          ).toLocaleString("en-us", {
                            month: "short",
                          })}`}
                          </span>
                          {tripInfo === "roundtrip" ? (
                            <>
                              {" "}
                              <span style={{ fontSize: 25, marginLeft: 10 }}>
                                -
                              </span>
                              <span style={{ fontSize: 25,fontWeight:'bold' }}>{`  ${new Date(
                                depart.substr(0, 10)
                              ).getDate()} ${new Date(
                                depart.substr(0, 10)
                              ).toLocaleString("en-us", {
                                month: "short",
                              })}`}</span>
                            </>
                          ) : (
                            ""
                          )}
                          {tripInfo === "roundtrip" ? (
                            <DateRangeNew />
                          ) : (
                            <DesktopDateNew />
                          )}
                          {/* <DesktopDateNew /> */}
                        </Box>
                      </Grid>
                      <Grid item xs={12} lg={ 2} style={{display:tripInfo === "roundtrip"?'none':''}} onClick={() => dispatch(setSelectedTrip("roundtrip"))}>
                        <Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                            padding: 11,
                            cursor:'pointer'
                          }}
                        >
                          <span style={{  }}>
                            RETURN
                           
                          </span><br></br>
                          <span style={{fontSize: 12,fontWeight:'bold',color:'grey'  }}>
                            Tab to add a return date for bigger discounts
                          </span>
                         
                        </Box>
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <Box
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 5,
                          }}
                        >
                          {/* <span style={{ fontSize: 38 }}>01</span>
                      <br></br>
                      <span style={{ fontSize: 12 }}>Travellers</span> */}
                          <ul
                            class="menu"
                            style={
                              {
                                // width: trip == "roundtrip" ? "110%" : "95%",
                              }
                            }
                          >
                            <li>
                              <a
                                style={{
                                  padding: 12,
                                  fontSize: 12,
                                  borderRadius: 4,
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  fontWeight: 600,
                                }}
                              >
                                <span style={{ fontSize: 30 }}>
                                  {adult + child + infant}
                                </span>
                                <br></br>
                                <span style={{ fontSize: 12 }}>Travellers</span>
                              </a>

                              <ul style={{ padding: 5, width: 243 }}>
                                <li>
                                  <Box
                                    style={{ padding: 5 }}
                                    display="flex"
                                    justifyContent="space-between"
                                    textAlign="center"
                                    alignItems="center"
                                  >
                                    <BodyText
                                      four
                                      textStyle={{
                                        color: "black",
                                        fontSize: 18,
                                        fontWeight: 500,
                                      }}
                                    >
                                      Adult
                                    </BodyText>
                                    <Box display="flex" alignItems="center">
                                      <Box
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          adult === 0 ? "" : setAdult(adult - 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 18,
                                            color: "white",
                                          }}
                                        >
                                          -
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          {adult}
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          adult + child + infant === 9
                                            ? adult
                                            : setAdult(adult + 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          +
                                        </BodyText>
                                      </Box>
                                    </Box>
                                  </Box>
                                </li>
                                <li>
                                  <Box
                                    style={{ padding: 5 }}
                                    display="flex"
                                    justifyContent="space-between"
                                    textAlign="center"
                                    alignItems="center"
                                  >
                                    <BodyText
                                      four
                                      textStyle={{
                                        color: "black",
                                        fontSize: 18,
                                        fontWeight: 500,
                                      }}
                                    >
                                      Child
                                    </BodyText>
                                    <Box display="flex" alignItems="center">
                                      <Box
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          child === 0 ? "" : setChild(child - 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 18,
                                            color: "white",
                                          }}
                                        >
                                          -
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          {child}
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          adult + child + infant === 9
                                            ? child
                                            : setChild(child + 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          +
                                        </BodyText>
                                      </Box>
                                    </Box>
                                  </Box>
                                </li>
                                <li>
                                  <Box
                                    style={{ padding: 5 }}
                                    display="flex"
                                    justifyContent="space-between"
                                    textAlign="center"
                                    alignItems="center"
                                  >
                                    <BodyText
                                      four
                                      textStyle={{
                                        color: "black",
                                        fontSize: 18,
                                        fontWeight: 500,
                                      }}
                                    >
                                      Infant
                                    </BodyText>
                                    <Box display="flex" alignItems="center">
                                      <Box
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          infant === 0
                                            ? ""
                                            : setInfant(infant - 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 18,
                                            color: "white",
                                          }}
                                        >
                                          -
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          {infant}
                                        </BodyText>
                                      </Box>
                                      <Box
                                        ml={"15px"}
                                        style={{
                                          cursor: "pointer",
                                          background: "rgb(239, 51, 57)",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                        }}
                                        onClick={() =>
                                          adult + child + infant === 9
                                            ? infant
                                            : setInfant(infant + 1)
                                        }
                                      >
                                        <BodyText
                                          textStyle={{
                                            fontSize: 17,
                                            color: "white",
                                          }}
                                        >
                                          +
                                        </BodyText>
                                      </Box>
                                    </Box>
                                  </Box>
                                </li>
                                <li>
                                  <Box
                                    style={{ padding: 10 }}
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Box className={classes.radio2}>
                                      <FormControl component="fieldset">
                                        <RadioGroup
                                          aria-label="gender"
                                          name="gender1"
                                          value={value}
                                          color="black"
                                          onChange={handleRadio}
                                        >
                                          <FormControlLabel
                                            value="Economy"
                                            control={<Radio />}
                                            label="Economy"
                                          />
                                          <FormControlLabel
                                            value="Business"
                                            control={<Radio />}
                                            label="Business"
                                          />
                                          <FormControlLabel
                                            value="First Class"
                                            control={<Radio />}
                                            label="First Class"
                                          />
                                          <FormControlLabel
                                            value="Premium Economy"
                                            control={<Radio />}
                                            label="Premium Economy"
                                          />
                                        </RadioGroup>
                                      </FormControl>
                                    </Box>
                                  </Box>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </Box>
                      </Grid>
                      
                    </Grid>
                    <Box style={{textAlign:'center'}}>
                    <input
                          type="submit"
                          value={'Search'}
                          style={{
                            border: "1px solid #767b8e",
                            borderRadius: 30,
                            // paddingLeft: 13,
                            backgroundColor: "#ff4600",
                            padding: '10px',
                            textAlign: "center",
                            borderColor: "#ff4600",
                            cursor: "pointer",
                            fontSize: 24,
                            color: "white",
                            width:'216px',
                            position: 'absolute',
    marginTop: '40px',
    marginLeft: '-115px'
                          }}
                        />
                    </Box>
                  </div>
                </>
              ) : section === "bus" ? (
               ''
              ) : section === "hotel" ? (
                ''
              ) : (
                ""
              )}
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default MMTForm;
